import { ProfiauswahlModal } from "../Pdf/ProfiAuswahl";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pdfSet } from "../Redux/pdfSlice";
import { IntToBetrag, IntToBetragText } from "../Helper/ZahlenFormat";
import { DelphiDatumShowText } from "../Helper/DateTimeHelper";
import { getKontoSoll, getKontoHaben } from "../Helper/PrKontoHelper";
import { getKlassenName } from "../Helper/PrKontoHelper";
export const KontenrahmenPdf = ({
  showProfiAuswahl,
  setShowProfiAuswahl,
  dataSource,
  user,
  jahr,
  klasse,
  mitSelektion,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDruckBtnClick = (art, profiName) => {
    //console.log("Profidruck Art",art);
    let defWidths; // = [20, 20, 20, 20, 20];
    let defAligns; // = ["left", "left", "left", "left", "left"];
    let defNachkommas; // = [0, 0, 0, 0, 0];
    let summeSoll = 0;
    let summeHaben = 0;
    let summeBilanzOpen = 0;
    let summeBilanzClose = 0;
    const getDatenZeilen = () => {
      const getDatenZeilenSpalten0 = (item) => {
        const retArray = [];
        retArray.push(item.konto);
        retArray.push(item.suchbeg);
        retArray.push(getKontoSoll(item));
        retArray.push(getKontoHaben(item));
        retArray.push(getKontoSoll(item) - getKontoHaben(item));
        retArray.push(item.bilanzopen);
        retArray.push(item.bilanzclose);
        summeSoll += getKontoSoll(item);
        summeHaben += getKontoHaben(item);
        summeBilanzOpen += item.bilanzopen;
        summeBilanzClose += item.bilanzclose;
        return retArray;
      };
      const getDatenZeilenSpalten1 = (item) => {
        const retArray = [];
        retArray.push(item.konto);
        retArray.push(item.suchbeg);
        retArray.push(getKontoSoll(item));
        retArray.push(getKontoHaben(item));
        retArray.push(getKontoSoll(item) - getKontoHaben(item));
        summeSoll += getKontoSoll(item);
        summeHaben += getKontoHaben(item);
        return retArray;
      };
      const arrDaten = [];
      const addFilterdaten = (item, index) => {
        console.log(item);
        switch (art) {
          case 1:
            arrDaten.push(getDatenZeilenSpalten1(item));
            break;
          default:
            arrDaten.push(getDatenZeilenSpalten0(item));
        }
      };
      switch (art) {
        case 1:
          defWidths = [9, 49, 14, 14, 14];
          defAligns = ["left", "left", "right", "right", "right"];
          defNachkommas = [2, 0, 2, 2, 2];
          arrDaten.push(["Konto", "Bezeichnung", "Soll", "Haben", "Saldo"]);
          break;

        default:
          defWidths = [9, 21, 14, 14, 14, 14, 14];
          defAligns = [
            "left",
            "left",
            "right",
            "right",
            "right",
            "right",
            "right",
          ];
          defNachkommas = [2, 0, 2, 2, 2, 2, 2];
          arrDaten.push([
            "Konto",
            "Bezeichnung",
            "Soll",
            "Haben",
            "Saldo",
            "Eröffn.",
            "Abschl.",
          ]);
      }
      dataSource.map(
        (item, index) => item.Id !== 0 && addFilterdaten(item, index)
      );
      //console.log("arrDaten", arrDaten);
      return arrDaten;
    };
    const getHeadDatenArray = () => {
      const getSelektiertInfo=()=>{
        if (mitSelektion)
          return "Ausgewählte ";
        return "Alle ";
      }
      switch (art) {
        case 1:
          return [
            [`${getSelektiertInfo()}Konten der Klasse ${getKlassenName(klasse)} im Jahr ${jahr}`],
            [""],
          ];
        default:
          return [
            [`${getSelektiertInfo()}Konten der Klasse ${getKlassenName(klasse)} im Jahr ${jahr}`],
            [""],
          ];
      }
    };
    const pdfTabelle = () => {
      const arrayDaten = [];
      switch (art) {
        case 1:
          arrayDaten.push({
            texte: getDatenZeilen(),
            widths: defWidths,
            aligns: defAligns,
            nachkommas: defNachkommas,
            fontSize: 11,
            fixedHead: true,
            fixedHeadLine: true,
            oddRowBackground: "#EEE",
            endeLinie: true,
          });
          arrayDaten.push({
            texte: [
              [
                "",
                "Summen",
                summeSoll,
                summeHaben,
                summeSoll - summeHaben,
              ],
            ],
            widths: defWidths,
            aligns: defAligns,
            nachkommas: defNachkommas,
            fontSize: 11,
          });
          break;
        default:
          arrayDaten.push({
            texte: getDatenZeilen(),
            widths: defWidths,
            aligns: defAligns,
            nachkommas: defNachkommas,
            fontSize: 11,
            fixedHead: true,
            fixedHeadLine: true,
            oddRowBackground: "#EEE",
            endeLinie: true,
          });
          arrayDaten.push({
            texte: [
              [
                "",
                "Summen",
                summeSoll,
                summeHaben,
                summeSoll - summeHaben,
                summeBilanzOpen,
                summeBilanzClose,
              ],
            ],

            widths: defWidths,
            aligns: defAligns,
            nachkommas: defNachkommas,
            fontSize: 11,
            //fixedHead: false,
            //fixedHeadLine: false,
            //oddRowBackground: "",
            //endeLinie: false,
          });
      }
      return arrayDaten;
    };

    const pdfDaten = {
      HomeLink: ["Konten", "/kontenrahmen"],
      PdfHead: {
        fixed: true,
        text: [
          ` ${jahr} / ${getKlassenName(klasse)}`,
          profiName,
          dayjs().format("DD.MM.YYYY"),
        ],
      },
      PdfHeadDatenArray: [{ texte: getHeadDatenArray(), fixed: true }],
      PdfDatenArray: pdfTabelle(),
      PdfFooterText: {
        textLink: "Powered by Aconsoft",
        textRechts: `${user.name}`,
      },
    };
    //console.log("XXX-pdfDaten", pdfDaten);
    dispatch(pdfSet(pdfDaten));
    navigate("/pdfViewhome");
  };

  return (
    <>
      <ProfiauswahlModal
        onConfirmOk={handleDruckBtnClick}
        onCancel={() => {
          setShowProfiAuswahl(false);
        }}
        visible={showProfiAuswahl}
        //title="Wählen Sie eine Druckvorlage"
        textArray={["Konten S/H/S/E/A", "Konten S/H/S"]}
        wahlCode="00001"
      />
    </>
  );
};
